function getThemeCartDrawer() {
  return document.querySelector('.cart-drawer-section cart-drawer') || document.querySelector('cart-drawer');
}

function kvIsCartAddUrl(url) {
  return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
}

function kvIsCartChangeUrl(url) {
  return typeof url === 'string' && (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1);
}

function kvRequestFilledDrawer(parsedState) {
  const drawer = getThemeCartDrawer();
  if (!drawer) return;
  clearTimeout(window.__kvCartDrawerTimer);
  window.__kvCartDrawerTimer = setTimeout(() => {
    drawer.renderContents(parsedState || {});
  }, 200);
}

function kvInstallCartAddHooks() {
  if (window.__kvCartDrawerHooks) return;
  window.__kvCartDrawerHooks = true;

  const nativeFetch = window.fetch;
  window.fetch = function () {
    const args = arguments;
    return nativeFetch.apply(this, args).then((response) => {
      const url = response.url || (typeof args[0] === 'string' ? args[0] : args[0] && args[0].url);
      if (kvIsCartAddUrl(url) && response.ok) {
        response
          .clone()
          .json()
          .then((data) => {
            if (!data.status) kvRequestFilledDrawer(data);
          })
          .catch(() => kvRequestFilledDrawer());
      } else if (kvIsCartChangeUrl(url) && response.ok) {
        response
          .clone()
          .json()
          .then((data) => {
            const drawer = getThemeCartDrawer();
            if (!drawer) return;
            if (typeof data.item_count === 'number') {
              drawer.syncDrawerAfterChange(data);
            } else {
              drawer.refreshDrawerTotals();
            }
          })
          .catch(() => {
            const drawer = getThemeCartDrawer();
            if (drawer) drawer.refreshDrawerTotals();
          });
      }
      return response;
    });
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__kvCartAdd = kvIsCartAddUrl(String(url || ''));
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__kvCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) kvRequestFilledDrawer();
      });
    }
    return nativeSend.apply(this, arguments);
  };

  ['cart-drawer:open', 'cart:open', 'cart:refresh', 'ajaxProduct:added', 'product:added', 'theme:cart:open'].forEach(
    (name) => {
      document.addEventListener(name, () => kvRequestFilledDrawer());
    }
  );

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '[aria-label="Add to Cart"], [aria-label="Add to cart"], .gp-button-atc, .gp-btn-addtocart, [data-gp-add-to-cart]'
      );
      if (!button) return;
      setTimeout(() => kvRequestFilledDrawer(), 800);
    },
    true
  );
}

kvInstallCartAddHooks();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', this.onBackdropClick.bind(this));
    this.setHeaderCartIconAccessibility();
    this.renderFreeGifts({
      total_price: Number(this.dataset.kvCartTotal || 0),
      item_count: Number(this.dataset.kvCartCount || 0),
    });
    this.bindFreeGiftsUpdates();
    this.bindCartKit();
  }

  connectedCallback() {
    this.captureHalloweenKit(this);
    this.ensureCartKitTemplate();
  }

  captureHalloweenKit(root) {
    const wrapper = (root || this).querySelector('.kv-halloween-cart-kit-wrapper');
    if (wrapper && wrapper.querySelector('.kv-halloween-cart-kit')) {
      this.__kvHwHtml = wrapper.innerHTML;
    }
    return wrapper;
  }

  restoreHalloweenKit(root) {
    const wrapper = (root || this).querySelector('.kv-halloween-cart-kit-wrapper');
    if (!wrapper) return null;
    if (!wrapper.querySelector('.kv-halloween-cart-kit') && this.__kvHwHtml) {
      wrapper.innerHTML = this.__kvHwHtml;
    } else if (wrapper.querySelector('.kv-halloween-cart-kit')) {
      this.__kvHwHtml = wrapper.innerHTML;
    }
    wrapper.style.display = 'none';
    return wrapper;
  }

  trainingKit(root) {
    return Array.from((root || this).querySelectorAll('.kv-cart-kit')).find(
      (el) => !el.classList.contains('kv-halloween-cart-kit') && !el.closest('.kv-halloween-cart-kit-wrapper')
    );
  }

  ensureCartKitTemplate() {
    if (this.__kvKitTemplate) return;
    const kit = this.trainingKit(this);
    if (!kit) return;
    this.__kvKitTemplate = kit.cloneNode(true);
  }

  ensureCartKitInDrawer(drawerRoot) {
    if (!drawerRoot) return null;
    this.ensureCartKitTemplate();
    const wrapper = drawerRoot.querySelector('.cartdrawer-item-wrapper') || drawerRoot.querySelector('.drawer__inner');
    let kit = this.trainingKit(drawerRoot);
    if (kit && wrapper) {
      const items = wrapper.querySelector('cart-drawer-items');
      if ((items && items.contains(kit)) || !wrapper.contains(kit)) wrapper.appendChild(kit);
    }
    if (!kit && this.__kvKitTemplate && wrapper) {
      kit = this.__kvKitTemplate.cloneNode(true);
      wrapper.appendChild(kit);
    }
    if (kit) this.__kvKitTemplate = kit.cloneNode(true);
    this.restoreHalloweenKit(drawerRoot);
    return kit;
  }

  bindCartKit() {
    if (this.dataset.kvKitBound === 'true') return;
    this.dataset.kvKitBound = 'true';
    this.addEventListener('click', (event) => {
      const option = event.target.closest('[data-kv-kit-option]');
      if (option) {
        event.preventDefault();
        this.onKitOptionClick(option);
        return;
      }
      const add = event.target.closest('[data-kv-kit-add]');
      if (add) {
        event.preventDefault();
        this.onKitAddClick(add);
      }
    });
  }

  getKitVariants(card) {
    const dataEl = card.querySelector('.kv-kit-variants');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent);
    } catch (error) {
      return [];
    }
  }

  getKitSelectedOptions(card) {
    const groups = card.querySelectorAll('[data-kv-kit-options]');
    if (!groups.length) return [];
    return Array.from(groups).map((group) => {
      const selected = group.querySelector('[data-kv-kit-option].is-selected');
      return selected ? selected.getAttribute('data-kv-option-value') : '';
    });
  }

  findKitVariant(variants, selectedOptions) {
    return variants.find((variant) => {
      const options = variant.options || [];
      return selectedOptions.every((value, index) => !value || options[index] === value);
    });
  }

  onKitOptionClick(button) {
    const card = button.closest('[data-kv-kit-card]');
    if (!card) return;
    const group = button.closest('[data-kv-kit-options]');
    group.querySelectorAll('[data-kv-kit-option]').forEach((option) => {
      option.classList.toggle('is-selected', option === button);
      option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
    });

    const variants = this.getKitVariants(card);
    const selected = this.getKitSelectedOptions(card);
    const variant = this.findKitVariant(variants, selected) || variants[0];
    if (!variant) return;

    card.dataset.kvVariantId = String(variant.id);
    const image = card.querySelector('.kv-kit-card-image');
    if (image && variant.image) {
      image.src = variant.image;
    }
    const price = card.querySelector('.kv-kit-add-price');
    if (price && variant.price_label) price.textContent = variant.price_label;
    const add = card.querySelector('[data-kv-kit-add]');
    if (add) add.toggleAttribute('disabled', variant.available === false);
  }

  onKitAddClick(button) {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const card = button.closest('[data-kv-kit-card]');
    const variantId = Number(card && card.dataset.kvVariantId);
    if (!variantId) return;

    const label = button.innerHTML;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Adding...';

    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          button.innerHTML = label;
          button.removeAttribute('aria-disabled');
          return;
        }
        this.renderContents(data);
      })
      .catch((error) => {
        console.error(error);
        button.innerHTML = label;
        button.removeAttribute('aria-disabled');
      });
  }

  bindFreeGiftsUpdates() {
    if (this.dataset.kvGiftsBound === 'true') return;
    this.dataset.kvGiftsBound = 'true';
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cart = event.cartData || {};
        if (typeof cart.item_count === 'number') {
          this.syncDrawerAfterChange(cart);
          return;
        }
        this.refreshDrawerTotals();
      });
    }
    this.watchFreeGifts();
  }

  setHeaderCartIconAccessibility() {
    if (this !== getThemeCartDrawer()) return;
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.openFromCartIcon(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.openFromCartIcon(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : this.querySelector('#CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  onBackdropClick(event) {
    if (event.target.closest('.drawer__inner')) return;
    if (
      event.target.classList.contains('cart-drawer__overlay') ||
      event.target.id === 'CartDrawer-Overlay' ||
      event.target === this ||
      event.target.id === 'CartDrawer'
    ) {
      this.close();
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState?.id;
    this.refreshFromCart(parsedState)
      .then(() => {
        this.open();
      })
      .catch((error) => console.error(error));
  }

  async refreshFromCart(parsedState = {}) {
    const cart = await fetch(`${routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' }).then((response) =>
      response.json()
    );
    const itemCount = cart.item_count || 0;

    let html = await this.loadDrawerHtml({ ...parsedState, item_count: itemCount });
    let sourceDrawer = this.parseCartDrawer(html);

    if (itemCount > 0 && sourceDrawer && !sourceDrawer.querySelector('.cart-item')) {
      html = await fetch(`${routes.cart_url}?section_id=cart-drawer&t=${Date.now()}`, { cache: 'no-store' }).then(
        (response) => response.text()
      );
      sourceDrawer = this.parseCartDrawer(html);
    }

    this.captureHalloweenKit(this);
    this.ensureCartKitTemplate();
    const targetDrawer = this.querySelector('#CartDrawer');
    if (sourceDrawer && targetDrawer) {
      targetDrawer.innerHTML = sourceDrawer.innerHTML;
      this.ensureCartKitInDrawer(targetDrawer);
    }
    this.restoreHalloweenKit(targetDrawer || this);

    this.syncEmptyState(itemCount);
    this.restoreEmptyCartBlocks();
    this.syncDrawerAfterChange(cart);
    this.updateCartIcon(parsedState, itemCount);
    return itemCount;
  }

  openFromCartIcon(cartLink) {
    fetch(`${routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' })
      .then((response) => response.json())
      .then((cart) => {
        if (cart.item_count > 0) {
          return this.refreshFromCart(cart);
        }
        this.syncEmptyState(0);
        this.restoreEmptyCartBlocks();
        this.syncDrawerAfterChange(cart);
      })
      .then(() => this.open(cartLink))
      .catch(() => this.open(cartLink));
  }

  restoreEmptyCartBlocks() {
    const template = this.querySelector(':scope > template.kv-empty-cart-blocks');
    const list = this.querySelector('.cart-drawer-list');
    if (!template || !list) return;
    if (list.querySelector('.cart-drawer-block')) return;
    list.innerHTML = template.innerHTML;
  }

  watchFreeGifts() {
    if (this.__kvGiftsObserver) return;
    this.__kvGiftsObserver = new MutationObserver(() => {
      if (this.__kvRenderingGifts) return;
      clearTimeout(this.__kvGiftsRestoreTimer);
      this.__kvGiftsRestoreTimer = setTimeout(() => {
        if (this.classList.contains('is-empty')) return;
        const root = this.querySelector('.kv-free-gifts');
        if (root && root.querySelector('.kv-free-gifts-message')) return;
        this.refreshFreeGiftsFromCart();
      }, 50);
    });
    this.__kvGiftsObserver.observe(this, { childList: true, subtree: true });
  }

  refreshFreeGiftsFromCart() {
    this.refreshDrawerTotals();
  }

  refreshDrawerTotals() {
    fetch(`${routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' })
      .then((response) => response.json())
      .then((cart) => this.syncDrawerAfterChange(cart))
      .catch((error) => console.error(error));
  }

  syncDrawerAfterChange(cart = {}) {
    if (typeof cart.item_count !== 'number') {
      this.refreshDrawerTotals();
      return;
    }
    const itemCount = cart.item_count;
    this._kvLastCart = cart;
    this.ensureCartKitInDrawer(this.querySelector('#CartDrawer'));
    this.syncEmptyState(itemCount);
    this.updateCountBubbles(itemCount);
    this.updateCartIcon(cart, itemCount);
    this.renderFreeGifts(cart);
    this.renderCartFooter(cart);
    this.syncHalloweenKit(cart);
    if (itemCount === 0) {
      this.restoreEmptyCartBlocks();
    }
  }

  syncHalloweenKit(cart = {}) {
    const wrapper = this.restoreHalloweenKit(this);
    if (!wrapper) return;
    const hideIds = String(this.dataset.kvHideVariants || '67962396573917,67962396541149,67962396606685')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    const items = Array.isArray(cart.items) ? cart.items : [];
    const inCart = items.some((item) => {
      const variantId = String(item.variant_id || item.id || '');
      return hideIds.indexOf(variantId) !== -1;
    });
    wrapper.style.display = 'none';
    if (inCart) {
      wrapper.setAttribute('hidden', '');
    } else {
      wrapper.removeAttribute('hidden');
    }
  }

  formatCartMoney(cents, currency) {
    const amount = Number(cents || 0) / 100;
    const code = currency || window.Shopify?.currency?.active || 'USD';
    if (Number.isNaN(amount)) return this.formatCartMoney(0, code);
    const whole = Math.round(amount * 100) % 100 === 0;
    const locale = document.documentElement.lang || undefined;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(amount);
    } catch (error) {
      const rounded = whole ? String(Math.round(amount)) : amount.toFixed(2);
      return `${code} ${rounded}`;
    }
  }

  getDiscountTitles(cart) {
    const titles = [];
    const addTitle = (title) => {
      if (title && titles.indexOf(title) === -1) titles.push(title);
    };
    (cart.cart_level_discount_applications || []).forEach((discount) => addTitle(discount.title));
    (cart.discount_applications || []).forEach((discount) => addTitle(discount.title));
    (cart.items || []).forEach((item) => {
      (item.discounts || []).forEach((discount) => addTitle(discount.title));
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        addTitle(allocation.discount_application?.title || allocation.title);
      });
    });
    return titles;
  }

  getDiscountLabel(cart = {}) {
    const titles = this.getDiscountTitles(cart);
    const normalized = titles.map((title) => String(title).toLowerCase());
    if (normalized.some((title) => title.indexOf('10 pairs') !== -1)) return 'Buy 4, Get 6 Free';
    if (normalized.some((title) => title.indexOf('5 pairs') !== -1)) return 'Buy 2, Get 3 Free';
    return titles.join(', ');
  }

  renderCartFooter(cart = {}) {
    const footer = this.querySelector('.kv-cart-footer');
    if (!footer) return;
    const itemCount = typeof cart.item_count === 'number' ? cart.item_count : 0;
    const total = typeof cart.total_price === 'number' ? cart.total_price : 0;
    const compare =
      typeof cart.original_total_price === 'number'
        ? cart.original_total_price
        : typeof cart.items_subtotal_price === 'number'
          ? cart.items_subtotal_price
          : total;
    const hasDiscount = compare > total || Number(cart.total_discount || 0) > 0;
    const discountTitle = this.getDiscountLabel(cart);
    const subtotalEl = footer.querySelector('.kv-cart-footer-subtotal');
    const compareEl = footer.querySelector('.kv-cart-footer-compare');
    const totalEl = footer.querySelector('.kv-cart-footer-total');
    const discountEl = footer.querySelector('.kv-cart-footer-discount');
    const checkout = footer.querySelector('.kv-cart-footer-checkout');

    if (subtotalEl) {
      const label = itemCount === 1 ? 'item' : 'items';
      subtotalEl.innerHTML = `Subtotal: <span class="kv-cart-footer-count">${itemCount}</span> ${label}`;
    }
    const currency = cart.currency || totalEl?.dataset.currency || window.Shopify?.currency?.active;
    if (compareEl) {
      compareEl.textContent = this.formatCartMoney(compare, currency);
      if (hasDiscount && compare > total) {
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.setAttribute('hidden', '');
      }
    }
    if (totalEl) totalEl.textContent = this.formatCartMoney(total, currency);
    if (discountEl) {
      discountEl.textContent = discountTitle;
      if (discountTitle) {
        discountEl.removeAttribute('hidden');
      } else {
        discountEl.setAttribute('hidden', '');
      }
    }
    if (checkout) checkout.toggleAttribute('disabled', itemCount === 0 || total < 400);
  }

  getMarketCurrency(cart = {}) {
    const shopifyCurrency = window.Shopify?.currency || {};
    const code = String(shopifyCurrency.active || cart.currency || this.dataset.kvCurrency || 'USD').toUpperCase();
    const rate = Number(shopifyCurrency.rate);
    return {
      code,
      rate: Number.isFinite(rate) && rate > 0 ? rate : 1,
    };
  }

  roundMarketAmount(value) {
    const amount = Math.round((Number(value) || 0) * 100) / 100;
    if (amount <= 0) return 0;
    const whole = Math.floor(amount);
    const fraction = Math.round((amount - whole) * 100) / 100;
    return fraction < 0.45 ? whole : whole + 1;
  }

  formatMarketAmount(amount, currency) {
    const rounded = this.roundMarketAmount(amount);
    const symbols = {
      ALL: { symbol: 'L', position: 'suffix' },
      AUD: { symbol: '$', position: 'prefix' },
      EUR: { symbol: '€', position: 'prefix' },
      USD: { symbol: '$', position: 'prefix' },
      CAD: { symbol: '$', position: 'prefix' },
      CZK: { symbol: 'Kč', position: 'suffix' },
      DKK: { symbol: 'kr.', position: 'suffix' },
      HUF: { symbol: 'Ft', position: 'suffix' },
      GBP: { symbol: '£', position: 'prefix' },
      CHF: { symbol: 'CHF', position: 'prefix' },
      MDL: { symbol: 'L', position: 'suffix' },
      NZD: { symbol: '$', position: 'prefix' },
      MKD: { symbol: 'ден', position: 'suffix' },
      PHP: { symbol: '₱', position: 'prefix' },
      PLN: { symbol: 'zł', position: 'suffix' },
      RON: { symbol: 'Lei', position: 'suffix' },
      RSD: { symbol: 'РСД', position: 'suffix' },
      SEK: { symbol: 'kr', position: 'suffix' },
      AED: { symbol: 'د.إ', position: 'prefix' },
    };
    const entry = symbols[currency] || { symbol: currency, position: 'prefix' };
    if (entry.position === 'suffix') return `${rounded} ${entry.symbol}`;
    const spacer = entry.symbol.length > 1 ? ' ' : '';
    return `${entry.symbol}${spacer}${rounded}`;
  }

  getFreeGiftsConfig() {
    const dataEl = this.querySelector(':scope > .kv-free-gifts-data');
    const fallback = {
      unlocked: "You've unlocked all free gifts!",
      gifts: [
        { title: 'Free Tummy Gummies', spend: 21, message: 'Free Tummy Gummies' },
        { title: 'Free Potty Training E-book', spend: 35, message: 'a FREE Potty Training E-book' },
        { title: 'Free Shipping + Reward Chart', spend: 68, message: 'FREE Shipping + Reward Chart & Stickers.' },
      ],
    };
    if (!dataEl) return fallback;
    try {
      const parsed = JSON.parse(dataEl.textContent);
      if (!parsed.gifts || !parsed.gifts.length) parsed.gifts = fallback.gifts;
      return parsed;
    } catch (error) {
      return fallback;
    }
  }

  renderFreeGifts(cart = {}) {
    this.__kvRenderingGifts = true;
    if (typeof cart.item_count === 'number') this._kvLastCart = cart;
    const itemCount = typeof cart.item_count === 'number' ? cart.item_count : this._kvLastCart?.item_count || 0;
    const total = typeof cart.total_price === 'number' ? cart.total_price : this._kvLastCart?.total_price || 0;
    let root = this.querySelector('.kv-free-gifts');

    if (!itemCount) {
      if (root) root.hidden = true;
      this.__kvRenderingGifts = false;
      return;
    }

    if (!root) {
      const wrapper = this.querySelector('.cartdrawer-item-wrapper') || this.querySelector('.drawer__inner');
      if (!wrapper) {
        this.__kvRenderingGifts = false;
        return;
      }
      root = document.createElement('div');
      root.className = 'kv-free-gifts';
      wrapper.prepend(root);
    }

    const config = this.getFreeGiftsConfig();
    const market = this.getMarketCurrency(cart);
    const gifts = config.gifts
      .map((gift) => ({
        ...gift,
        spend: this.roundMarketAmount((Number(gift.spend) || 0) * market.rate),
      }))
      .filter((gift) => gift.spend > 0)
      .sort((a, b) => a.spend - b.spend);

    if (!gifts.length) {
      root.hidden = true;
      this.__kvRenderingGifts = false;
      return;
    }

    const nextIndex = gifts.findIndex((gift) => gift.spend * 100 > total);
    const leftIndex = nextIndex <= 0 ? 0 : Math.min(nextIndex, gifts.length - 1) - (nextIndex === -1 ? 0 : 1);
    const visibleLeft = nextIndex === -1 ? gifts[Math.max(gifts.length - 2, 0)] : gifts[Math.max(leftIndex, 0)];
    const visibleRight =
      nextIndex === -1 ? gifts[gifts.length - 1] : gifts[Math.min(Math.max(nextIndex, 1), gifts.length - 1)];
    const nextGift = nextIndex === -1 ? null : gifts[nextIndex];
    const progressTarget = nextGift || gifts[gifts.length - 1];
    const percent = Math.min(100, Math.max(0, (total / (progressTarget.spend * 100)) * 100));
    const away = nextGift ? Math.max(0, Math.ceil((nextGift.spend * 100 - total) / 100)) : 0;
    const message = nextGift
      ? `You're only ${this.formatMarketAmount(away, market.code)} away from ${nextGift.message || nextGift.title}`
      : config.unlocked || "You've unlocked all free gifts!";

    const escapeText = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const milestoneHtml = (gift, end) => `
        <div class="kv-free-gifts-milestone${end ? ' kv-free-gifts-milestone-end' : ''}">
          <span class="kv-free-gifts-title">${escapeText(gift.title)}</span>
          <span class="kv-free-gifts-spend">Spend ${escapeText(this.formatMarketAmount(gift.spend, market.code))}</span>
        </div>`;
    const milestonesHtml =
      gifts.length === 1
        ? milestoneHtml(visibleRight, true)
        : `${milestoneHtml(visibleLeft, false)}${milestoneHtml(visibleRight, true)}`;

    root.hidden = false;
    root.innerHTML = `
      <p class="kv-free-gifts-message">${escapeText(message)}</p>
      <div class="kv-free-gifts-track">
        <div class="kv-free-gifts-bar" style="width:${percent}%"></div>
        <div class="kv-free-gifts-thumb" style="left:${percent}%"></div>
      </div>
      <div class="kv-free-gifts-milestones">${milestonesHtml}
      </div>
    `;
    this.dataset.kvCartTotal = String(total);
    this.dataset.kvCartCount = String(itemCount);
    this._kvLastCart = { item_count: itemCount, total_price: total };
    this.__kvRenderingGifts = false;
  }

  async loadDrawerHtml(parsedState) {
    const fromResponse = parsedState?.sections?.[this.dataset.section] || parsedState?.sections?.['cart-drawer'];
    if (fromResponse && this.parseCartDrawer(fromResponse)?.querySelector('.cart-item')) return fromResponse;

    const sectionId = this.dataset.section || 'cart-drawer';
    const urls = [
      `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&t=${Date.now()}`,
      `${routes.cart_url}?section_id=cart-drawer&t=${Date.now()}`,
    ];

    for (const url of urls) {
      try {
        const response = await fetch(url, { cache: 'no-store' });
        if (!response.ok) continue;
        const html = await response.text();
        if (this.parseCartDrawer(html)) return html;
      } catch (error) {
        console.error(error);
      }
    }

    return fromResponse || '';
  }

  parseCartDrawer(html) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
  }

  syncEmptyState(itemCount) {
    const isEmpty = !itemCount;
    this.classList.toggle('is-empty', isEmpty);
    this.querySelector('cart-drawer-items')?.classList.toggle('is-empty', isEmpty);
    const total = typeof this._kvLastCart?.total_price === 'number' ? this._kvLastCart.total_price : null;
    this.querySelector('#CartDrawer-Checkout')?.toggleAttribute('disabled', isEmpty || (total !== null && total < 400));
    const kit = this.trainingKit(this);
    if (kit) kit.hidden = isEmpty;
  }

  updateCountBubbles(itemCount) {
    const count = Number(itemCount) || 0;
    this.querySelectorAll('.kv-cart-count-bubble').forEach((bubble) => {
      bubble.textContent = String(count);
      if (count < 1) {
        bubble.setAttribute('hidden', '');
      } else {
        bubble.removeAttribute('hidden');
      }
    });
  }

  updateCartIcon(parsedState, itemCount) {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    const iconHtml = parsedState?.sections?.['cart-icon-bubble'];
    if (iconHtml) {
      try {
        icon.innerHTML = this.getSectionInnerHTML(iconHtml, '.shopify-section');
        return;
      } catch (error) {
        console.error(error);
      }
    }

    let bubble = icon.querySelector('.cart-count-bubble');
    if (!itemCount) {
      bubble?.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span>';
      icon.appendChild(bubble);
    }
    const count = bubble.querySelector('[aria-hidden="true"]') || bubble.querySelector('span');
    if (count) count.textContent = itemCount;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const sectionId = this.dataset.section || 'cart-drawer';
    const sections = [
      {
        id: sectionId,
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
    if (sectionId !== 'cart-drawer') {
      sections.push({
        id: 'cart-drawer',
        selector: '#CartDrawer',
        fallback: true,
      });
    }
    return sections;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const drawer = this.closest('cart-drawer');
    const section = drawer?.dataset.section || 'cart-drawer';
    return [
      {
        id: 'CartDrawer',
        section,
        selector: '#CartDrawer-CartItems',
      },
      {
        id: 'CartDrawer',
        section,
        selector: '.kv-cart-footer',
      },
      {
        id: 'CartDrawer',
        section,
        selector: '.drawer__heading .kv-cart-count-bubble',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  onCartUpdate() {
    const drawer = this.closest('cart-drawer');
    if (!drawer || !drawer.closest('.shopify-section')) return;
    if (typeof drawer.refreshFromCart === 'function') {
      drawer.refreshFromCart();
    }
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
